import type { ReactNode } from "react";
import {
  Controller,
  type Control,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";

import { Field } from "~/components/ui";

type FieldRenderProps = {
  value: unknown;
  onChangeText: (value: string) => void;
  onBlur: () => void;
  invalid: boolean;
  accessibilityLabel: string;
  accessibilityHint?: string;
};

/** React Hook Form wrapper around the `Field` primitive. */
export function FormField<TFieldValues extends FieldValues>({
  control,
  name,
  label,
  description,
  children,
}: {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  description?: string;
  children: (props: FieldRenderProps) => ReactNode;
}) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Field
          label={label}
          description={description}
          error={fieldState.error?.message}
        >
          {children({
            value: field.value,
            onChangeText: field.onChange,
            onBlur: field.onBlur,
            invalid: Boolean(fieldState.error),
            accessibilityLabel: label,
            accessibilityHint: description,
          })}
        </Field>
      )}
    />
  );
}
